// Editor de alertas de uma data da ficha (texto 10, A4): o MESMO da Nova tarefa (AlertasEditor), com
// "Como avisar" e "Testar". Data sem horário: "Sem alerta" e "Em um horário específico" (X dias antes ou no dia).
// Com horário (campo 'hora' logo depois da data): também "No início" e "Antes do início".
// Os alertas só avisam no celular; "Colocar no My Planner" é outra escolha.
import { Text, View } from 'react-native';
import type { ModId } from '../store/types';
import type { Campo, Colecao } from '../modulos/tipos';
import { alertasDoCampo, comAlertas, diasDoCampo, horaDoCampo } from '../modulos/alertas';
import { t } from '../lib/i18n';
import { AlertasEditor } from './AlertasEditor';
import { C } from './theme';

type Props = { col: Colecao; f: Campo; c: Record<string, any>; mod: ModId; cor: string;
  setC: (fn: (x: Record<string, any>) => Record<string, any>) => void };

export function AlertasDaFicha({ col, f, c, mod, cor, setC }: Props) {
  if (!c[f.k]) return null;   // sem data, sem alerta
  const h = horaDoCampo(col, f);
  const hora = h ? c[h.k] : null;
  return (
    <View style={{ gap: 6 }}>
      <Text style={{ color: C.sub, fontSize: 12 }}>🔔 {t('Alertas: {campo}', { campo: t(f.r) })}</Text>
      <AlertasEditor itens={alertasDoCampo(c, f)} onChange={l => setC(x => comAlertas(x, f.k, l))}
        temHorario={!!hora} horaPadrao={hora || null} cor={cor} aba={mod} dias={diasDoCampo(f)} />
    </View>
  );
}
